import React, { Component } from 'react';
import SettingsModal from './SettingsModal';
import { connect } from 'react-redux';
import logo from '../static/hopscotch_logo2.png';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    Container
} from 'reactstrap';
import DatePicker from "react-datepicker";

import { 
    getItems, 
    getTabletStatus,
    setDate,
    addItems,
    updateItems,
    setItemsLoading
} from '../actions/itemActions';
import PubNubReact from 'pubnub-react';
import audio from '../static/hopscotch_audio.mp3';
 
import "react-datepicker/dist/react-datepicker.css";
const constants = require('../components/constants');
const STATE_ORDER_CANCELLED = constants.STATE_ORDER_CANCELLED;
const STATE_ORDER_CANCELLED_AFTER_COLLECTION = constants.STATE_ORDER_CANCELLED_AFTER_COLLECTION;
const STATE_ORDER_REJECTED = constants.STATE_ORDER_REJECTED;

let jingle = new Audio(audio);

// How often the polling fallback re-fetches orders (milliseconds).
const POLL_INTERVAL_MS = 4000;
// How often to refresh when each restaurant tablet last checked in.
const TABLET_STATUS_INTERVAL_MS = 30000;

class AppNavbar extends Component {
    constructor(props) {
        super(props);
        // PubNub disabled — polling (componentDidMount) is now the sole delivery path.
        // this.initializePubNub();
        this.props.setItemsLoading();
        this.props.setDate(new Date());
        this.props.getItems();
    }

    // Tracks each item's last-seen alert state, so we can ring the jingle on NEW
    // orders / restaurant actions detected from polled data (replacing the old
    // PubNub playJingle push). null = not yet seeded (don't ring on first load).
    alertState = null;

    // Polling fallback — re-fetch orders every POLL_INTERVAL_MS. Self-heals after
    // network blips; no long-lived connection to wedge. getItems() no-ops until a
    // dispatcher (hopscotch_id) is configured, so this is safe to run unconditionally.
    componentDidMount() {
        this.pollIntervalId = setInterval(() => {
            this.props.getItems();
        }, POLL_INTERVAL_MS);

        this.props.getTabletStatus();
        this.tabletStatusIntervalId = setInterval(() => {
            this.props.getTabletStatus();
        }, TABLET_STATUS_INTERVAL_MS);

        // Autoplay policy (esp. Safari) blocks jingle.play() when it's fired from the
        // polling callback rather than a user gesture. Unlock the audio on the first
        // user interaction (play+pause within the gesture); after that, poll-triggered
        // dings are allowed for the rest of the session.
        this.audioUnlockHandler = () => this.unlockAudio();
        document.addEventListener('click', this.audioUnlockHandler);
        document.addEventListener('keydown', this.audioUnlockHandler);
        document.addEventListener('touchstart', this.audioUnlockHandler);
    }

    unlockAudio = () => {
        try {
            const p = jingle.play();
            if (p !== undefined && p !== null) {
                p.then(() => {
                    jingle.pause();
                    jingle.currentTime = 0;
                }).catch(() => {});
            }
        } catch (err) {
            // ignore — we'll try again on the next gesture if listeners are still attached
        }
        this.removeAudioUnlockListeners();
    }

    removeAudioUnlockListeners = () => {
        if (this.audioUnlockHandler) {
            document.removeEventListener('click', this.audioUnlockHandler);
            document.removeEventListener('keydown', this.audioUnlockHandler);
            document.removeEventListener('touchstart', this.audioUnlockHandler);
        }
    }
    pubnubListener = { 
        message: payload => {  
            if (payload.message.refresh /*&& payload.message.refreshHopscotchType !== 'task'*/){
                //this.props.setItemsLoading();
                //console.log(`Message is ${JSON.stringify(payload.message)}`);
                if(payload.message.new_items || payload.message.updated_items){
                    if(payload.message.new_items){
                        this.props.addItems(payload.message.new_items);
                    } 
                    
                    if (payload.message.updated_items){
                        // If a restaurant sends a message on an item that isn't showing on MC (eg, it's from today, complete 
                        // and MC has "Don't show complete items" enabled, or it's from yesterday and complete), 
                        // then add it 
                        if(payload.message.updated_items.length===1 && 
                            !this.props.globalState.items.find(item => item._id===payload.message.updated_items[0]._id) && 
                            payload.message.updated_items[0].messages.some(m => m.sender !== "Hopscotch" && !m.readByHopscotch)
                            ){
                            this.props.addItems(payload.message.updated_items);
                        } else {
                            this.props.updateItems(payload.message.updated_items);
                        }
                    }
                } else {
                    this.props.setItemsLoading();
                    this.props.getItems();
                }
                
            }

            if (payload.message.playJingle){
                this.playJingle();
            }
        } 
    }

    componentDidUpdate(prevProps){
        const settings = this.props.globalState.settings;
        let getItems = false;
        if(new Date(prevProps.globalState.settings.date).toDateString() !==
           new Date(settings.date).toDateString()){
            //this.props.setItemsLoading();
           // this.props.setDate(new Date(settings.date));
            //this.props.getItems(this.callback);
            getItems = true;
        }
        if(prevProps.globalState.settings.hopscotch_id !== settings.hopscotch_id){
            // PubNub disabled — polling handles delivery.
            // this.initializePubNub();
            //this.props.setItemsLoading();
            //this.props.getItems(this.callback);
            getItems = true;
        }

        if(prevProps.globalState.settings.showAllOrders !== settings.showAllOrders){
            getItems= true;
        }

        if(getItems){
            // A date/dispatcher/filter change reloads a different set of orders;
            // re-seed alert state so we don't ring for orders that were already open.
            this.alertState = null;
            this.props.setItemsLoading();
            this.props.getItems();
        }

        // Ring the jingle for newly-arrived orders / restaurant actions, detected
        // from the polled data (replaces the old PubNub playJingle push). Skip while
        // loading: ITEMS_LOADING transiently empties the list, which would otherwise
        // seed an empty baseline and then ring for every order on the real load.
        if(prevProps.globalState.items !== this.props.globalState.items &&
           !this.props.globalState.loading){
            this.scanForAlerts(this.props.globalState.items);
        }
    }

    // Number of restaurant->Hopscotch messages that Hopscotch hasn't read yet.
    // Counted (not just a boolean) so a 2nd/3rd message rings, matching the old
    // per-message PubNub behaviour.
    countUnreadRestaurantMessages = item =>
        (!!item && Array.isArray(item.messages))
            ? item.messages.filter(m => m.sender !== "Hopscotch" && !m.readByHopscotch).length
            : 0;

    // Compare this poll's items to the previous poll and ring once if any item is
    // newly present, has a NEW unread restaurant message (count rose), or is newly
    // flagged problem / accepted. Mirrors the lambda's old playJingleForHopscotch
    // conditions. Seeds silently on first load and after a re-seed.
    scanForAlerts = items => {
        const current = new Map();
        for(const item of (items || [])){
            if(!item || !item._id) continue;
            current.set(item._id, {
                unreadCount: this.countUnreadRestaurantMessages(item),
                problem: !!item.problem,
                accepted: !!item.accepted
            });
        }

        if(this.alertState === null){
            // First scan (or just re-seeded after a filter change): record, don't ring.
            this.alertState = current;
            return;
        }

        let shouldJingle = false;
        for(const [id, state] of current){
            const prev = this.alertState.get(id);
            if(!prev){
                // A brand-new order/item that wasn't in the previous poll.
                shouldJingle = true;
            } else if((state.unreadCount > prev.unreadCount) ||
                      (state.problem && !prev.problem) ||
                      (state.accepted && !prev.accepted)){
                // A new restaurant message (unread count rose), or a newly flagged
                // problem / acceptance on an existing order.
                shouldJingle = true;
            }
        }

        this.alertState = current;
        if(shouldJingle){
            this.playJingle();
        }
    }

    componentWillUnmount() {
        if(this.pollIntervalId){
            clearInterval(this.pollIntervalId);
        }
        if(this.tabletStatusIntervalId){
            clearInterval(this.tabletStatusIntervalId);
        }
        this.removeAudioUnlockListeners();
        if(this.pubnub){
            this.pubnub.removeListener(this.pubnubListener);
            this.pubnub.unsubscribeAll();
        }
    }

    initializePubNub = () => {
        const settings = this.props.globalState.settings;
        if(settings.pubnub_publish_key && settings.pubnub_subscribe_key && settings.hopscotch_id){
            if(!this.pubnub){
                this.pubnub = new PubNubReact({ 
                    publishKey: settings.pubnub_publish_key, 
                    subscribeKey: settings.pubnub_subscribe_key
                });
                this.pubnub.init(this);
                this.pubnub.addListener(this.pubnubListener); 
            }
    
            this.pubnub.unsubscribeAll();
            this.pubnub.subscribe({ 
                channels: [settings.hopscotch_id] 
            });
        }
    }

    playJingle = () => {
        try{
            let playPromise = jingle.play();
            if (playPromise !== null){
                playPromise.catch(() => jingle.play() );
            }
        }catch(err){
            console.log(`Caught error playing jingle: ${err}. Trying again...`);
            jingle.play();
        }
    }
    state = {
        isOpen: false
    }
  
    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    handleDateChange = date => {
        this.props.setDate(date);
    }

    render(){
        
        const { settings, items /*, loading */} = this.props.globalState;
        const selectedDate = (settings && settings.date) ? new Date(settings.date) : new Date();
        const orderIds = [];
        let itemStatus;
        let numOrders = items.reduce((prevNumOrders, item) => {
                itemStatus = item.history.length > 0 ? item.history[item.history.length-1].status : null;
                if(
                    itemStatus !== STATE_ORDER_CANCELLED && 
                    itemStatus !== STATE_ORDER_CANCELLED_AFTER_COLLECTION &&
                    itemStatus !== STATE_ORDER_REJECTED &&
                    !orderIds.includes(item.order.id) 
                ){
                        orderIds.push(item.order.id);
                        return prevNumOrders+1;
                } else {
                    return prevNumOrders;
                }    
            }, 0
        );
        let excludesText = settings.showAllOrders ? 
        "Excludes cancelled and rejected orders. " : 
        "Excludes cancelled, rejected and completed orders, except those with messages unread by Hopscotch. ";
        return (
                <Navbar sticky="top" style={{backgroundColor: '#a32273'}} dark expand="sm" className="mb-5">
                    <Container>
                        <div style={{width: '25%', display: 'inline'}}>
                            <img style={{maxWidth: '100%', maxHeight: '100%'}} src={logo} alt="Hopscotch"/>
                        </div>
                        <span style={{color: 'white', width: '80%', textAlign: 'center'}}>
                            {settings.hopscotch_id ? "Mission Control" : "[Mission Control not configured]"}
                        </span>
                        {
                           /* loading ?
                            <span style={{width: '20%', textAlign: 'center'}}>
                                <ClipLoader
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#ffff'}
                                    loading={true}
                                />
                            </span> : */
                            <span title={excludesText+"A multi-restaurant order counts as 1 order."} style={{color: 'white', width: '20%', textAlign: 'center'}}>
                            {`${numOrders} ${settings.showAllOrders?'':'active'} order${numOrders!==1?"s":""}`}
                            </span>
                        }
                        

                        <DatePicker 
                            selected={selectedDate} 
                            onChange={this.handleDateChange} 
                            dateFormat="EEE, MMMM d"
                        />
                        
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <a className="nav-link" href="/shadow" target="_blank" rel="noopener noreferrer">Shadow dispatcher</a>
                                </NavItem>
                                <NavItem>
                                    <SettingsModal />
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Container>
                </Navbar>
        );
    }
}

const mapStateToProps = (state) => ({
    globalState: state.item
});

export default connect(mapStateToProps, { 
    addItems,
    updateItems,
    getItems, 
    getTabletStatus,
    setDate,
    setItemsLoading
} )(AppNavbar);